import cx from "classnames";
import { useState } from "react";
import LazyLoad from "react-lazyload";
import "./FeatureSection.scss";

const ImagePosition = Object.freeze({
  LEFT: "left",
  RIGHT: "right",
});

type Props = {
  /** Title */
  title: any;
  /** Text */
  text: any;
  /** Image source */
  imageSrc: string;
  /** Image source set for responsive */
  imageSrcSet: string;
  /** If the image position should be left or right, text will be opposite */
  imagePosition: any;
  isVisible: boolean;
};

const FeatureSection: React.FC<Props> = ({
  title,
  text,
  imageSrc,
  imageSrcSet,
  imagePosition,
  isVisible,
}) => {
  const [isImageVisible, setIsImageVisible] = useState(false);

  const featureSectionClasses = cx("feature-section", {
    "feature-section--reverse": imagePosition === ImagePosition.LEFT,
    "feature-section--fade-in-left":
      imagePosition === ImagePosition.LEFT && isVisible,
    "feature-section--fade-in-right":
      imagePosition === ImagePosition.RIGHT && isVisible,
  });

  return (
    <div className={featureSectionClasses}>
      <div className="feature-section__col">
        <h2 className="feature-section__title grotesk-font">{title}</h2>
        <div className="feature-section__text">{text}</div>
      </div>
      <div className="feature-section__col">
        <LazyLoad>
          <img
            className="feature-section__image"
            alt={title}
            src={imageSrc}
            srcSet={imageSrcSet}
            onLoad={() => setIsImageVisible(true)}
          />
        </LazyLoad>
      </div>
    </div>
  );
};

FeatureSection.defaultProps = {
  imagePosition: ImagePosition.RIGHT,
};

export default FeatureSection;
export { ImagePosition };
